import { type_POPUP_LOADING, type_POPUP_ONBOARD } from '../types'

export const initialState = {
    onboard: false,
    loading: false,
}

type TType = typeof type_POPUP_ONBOARD | typeof type_POPUP_LOADING

type Onboard = {
    type: TType
    payload: boolean
}

export const popupReducer = (
    state = initialState,
    { type, payload }: Onboard
) => {
    switch (type) {
        case type_POPUP_ONBOARD:
            return { ...state, onboard: payload }
        case type_POPUP_LOADING:
            return { ...state, loading: payload }
        default:
            return state
    }
}
